var map = {
  'dd-MMM-yyyy HH:mm': {
    dateFormat: 'DD-MMM-YYYY',
    dateTimeFormat: 'DD-MMM-YYYY HH:mm',
    dateTimeTzFormat: 'DD-MMM-YYYY HH:mm z'
  },
  'dd/MM/yy HH:mm': { dateFormat: 'DD/MM/YY', dateTimeFormat: 'DD/MM/YY HH:mm', dateTimeTzFormat: 'DD/MM/YY HH:mm z' },
  'MM/dd/yyyy HH:mm': {
    dateFormat: 'MM/DD/YYYY',
    dateTimeFormat: 'MM/DD/YYYY HH:mm',
    dateTimeTzFormat: 'MM/DD/YYYY HH:mm z'
  },
  'yyyy/MM/dd HH:mm': {
    dateFormat: 'YYYY/MM/DD',
    dateTimeFormat: 'YYYY/MM/DD HH:mm',
    dateTimeTzFormat: 'YYYY/MM/DD HH:mm z'
  },
  'yyyy-MM-dd HH:mm': {
    dateFormat: 'YYYY-MM-DD',
    dateTimeFormat: 'YYYY-MM-DD HH:mm',
    dateTimeTzFormat: 'YYYY-MM-DD HH:mm z'
  },
  'yyyy-MMM-dd HH:mm': {
    dateFormat: 'YYYY-MMM-DD',
    dateTimeFormat: 'YYYY-MMM-DD HH:mm',
    dateTimeTzFormat: 'YYYY-MMM-DD HH:mm z'
  }
};

export default map;